"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$lead$client, _vm$lead$clientsConta, _vm$lead$clientsConta2, _vm$lead$clientsConta3, _vm$lead$clientsConta4, _vm$lead$clientsConta5, _vm$lead$clientsConta6, _vm$lead$clientsConta7, _vm$lead$clientsConta8, _vm$lead$clientsConta9, _vm$lead$salesManager, _vm$lead$salesCoordin, _vm$lead$salesManager2, _vm$lead$source, _vm$selectedFollowup, _vm$selectedFollowup2, _vm$selectedFollowup3;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 24,
      md: 9,
      lg: 9
    }
  }, [_c("el-card", {
    staticClass: "detail-card info-card shadow-sm",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticClass: "card-header gradient-orange-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", {
    staticClass: "header-title"
  }, [_c("i", {
    staticClass: "el-icon-info icon-accent"
  }), _vm._v(" Lead Details")]), _c("div", {
    staticClass: "header-actions"
  }, [(_vm.lead.salesCoordinatorId === _vm.loggedInUser.id || _vm.lead.salesManagerId === _vm.loggedInUser.id) && _vm.lead.status !== "Lost" && _vm.lead.status !== "Won" ? _c("el-button", {
    attrs: {
      plain: "",
      type: "danger",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.lostInquiryFormVisible = true;
      }
    }
  }, [_vm._v(" Mark the Lead as Lost ")]) : _vm._e(), _vm.canReopen(_vm.lead) ? _c("el-button", {
    attrs: {
      plain: "",
      type: "warning",
      size: "mini"
    },
    on: {
      click: function ($event) {
        return _vm.handleReopenLead(_vm.lead.id);
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Reopen Lead ")]) : _vm._e(), _c("div", {
    class: "status-badge status-" + _vm.lead.status
  }, [_vm._v(" " + _vm._s(_vm.lead.status) + " ")])], 1)]), _c("el-descriptions", {
    staticClass: "beautified-descriptions",
    attrs: {
      column: 1,
      size: "medium",
      border: ""
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-key"
  }), _vm._v(" ID ")]), _c("span", {
    staticClass: "id-text"
  }, [_vm._v("#" + _vm._s(_vm.lead.id))])], 2), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-office-building"
  }), _vm._v(" Client ")]), _c("div", {
    staticClass: "client-info"
  }, [_c("div", {
    staticClass: "client-row1"
  }, [_c("span", {
    staticClass: "client-name"
  }, [_vm._v(_vm._s((_vm$lead$client = _vm.lead.client) === null || _vm$lead$client === void 0 ? void 0 : _vm$lead$client.name))]), _c("span", {
    staticClass: "contact-person"
  }, [_c("i", {
    staticClass: "el-icon-user"
  }), _vm._v(" " + _vm._s((_vm$lead$clientsConta = _vm.lead.clientsContact) === null || _vm$lead$clientsConta === void 0 ? void 0 : _vm$lead$clientsConta.firstName) + " " + _vm._s((_vm$lead$clientsConta2 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta2 === void 0 ? void 0 : _vm$lead$clientsConta2.lastName))]), (_vm$lead$clientsConta3 = _vm.lead.clientsContact) !== null && _vm$lead$clientsConta3 !== void 0 && _vm$lead$clientsConta3.communicationPreference ? _c("el-tooltip", {
    attrs: {
      placement: "top",
      effect: "dark",
      "popper-class": "pref-tooltip",
      trigger: "click"
    }
  }, [_c("div", {
    staticClass: "pref-tooltip-content",
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("span", {
    staticClass: "pref-tooltip-label"
  }, [_vm._v("Prefers")]), _c("span", {
    staticClass: "pref-tooltip-value"
  }, [_vm._v(_vm._s((_vm$lead$clientsConta4 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta4 === void 0 ? void 0 : _vm$lead$clientsConta4.communicationPreference))])]), _c("el-tag", {
    staticStyle: {
      cursor: "pointer"
    },
    attrs: {
      size: "mini",
      effect: "plain",
      type: "info"
    }
  }, [_vm._v(" " + _vm._s((_vm$lead$clientsConta5 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta5 === void 0 ? void 0 : _vm$lead$clientsConta5.communicationPreference) + " ")])], 1) : _vm._e()], 1), _c("div", {
    staticClass: "client-row2"
  }, [_c("el-popover", {
    attrs: {
      trigger: "manual",
      placement: "top",
      width: "280",
      "popper-class": "pref-warning-popover"
    },
    model: {
      value: _vm.emailPrefWarningVisible,
      callback: function ($$v) {
        _vm.emailPrefWarningVisible = $$v;
      },
      expression: "emailPrefWarningVisible"
    }
  }, [_c("div", {
    staticClass: "pref-warn-body"
  }, [_c("div", {
    staticClass: "pref-warn-msg"
  }, [_c("i", {
    staticClass: "el-icon-warning pref-warn-icon"
  }), _c("span", [_vm._v("This client prefers "), _c("b", [_vm._v(_vm._s((_vm$lead$clientsConta6 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta6 === void 0 ? void 0 : _vm$lead$clientsConta6.communicationPreference))]), _vm._v(". Are you sure you want to reach out via Email instead?")])]), _c("div", {
    staticClass: "pref-warn-actions"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.emailPrefWarningVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.confirmEmailOpen
    }
  }, [_vm._v(" Continue ")])], 1)]), _c("div", {
    staticClass: "contact-item contact-clickable",
    attrs: {
      slot: "reference"
    },
    on: {
      click: _vm.handleEmailClick
    },
    slot: "reference"
  }, [_c("i", {
    staticClass: "el-icon-message"
  }), _c("span", [_vm._v(_vm._s((_vm$lead$clientsConta7 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta7 === void 0 ? void 0 : _vm$lead$clientsConta7.emailAddress))]), _c("el-button", {
    staticStyle: {
      padding: "0"
    },
    attrs: {
      type: "text",
      icon: "el-icon-edit",
      size: "mini"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.promptEditEmail.apply(null, arguments);
      }
    }
  })], 1)]), _c("el-popover", {
    attrs: {
      trigger: "manual",
      placement: "top",
      width: "280",
      "popper-class": "pref-warning-popover"
    },
    model: {
      value: _vm.mobilePrefWarningVisible,
      callback: function ($$v) {
        _vm.mobilePrefWarningVisible = $$v;
      },
      expression: "mobilePrefWarningVisible"
    }
  }, [_c("div", {
    staticClass: "pref-warn-body"
  }, [_c("div", {
    staticClass: "pref-warn-msg"
  }, [_c("i", {
    staticClass: "el-icon-warning pref-warn-icon"
  }), _c("span", [_vm._v("This client prefers "), _c("b", [_vm._v(_vm._s((_vm$lead$clientsConta8 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta8 === void 0 ? void 0 : _vm$lead$clientsConta8.communicationPreference))]), _vm._v(". Are you sure you want to reach out via Phone instead?")])]), _c("div", {
    staticClass: "pref-warn-actions"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.mobilePrefWarningVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.confirmMobileOpen
    }
  }, [_vm._v(" Continue ")])], 1)]), _c("div", {
    staticClass: "contact-item contact-clickable",
    attrs: {
      slot: "reference"
    },
    on: {
      click: _vm.handleMobileClick
    },
    slot: "reference"
  }, [_c("i", {
    staticClass: "el-icon-mobile-phone"
  }), _c("span", [_vm._v(_vm._s((_vm$lead$clientsConta9 = _vm.lead.clientsContact) === null || _vm$lead$clientsConta9 === void 0 ? void 0 : _vm$lead$clientsConta9.mobileNumber))])])])], 1)])], 2), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-user"
  }), _vm._v(" Team ")]), _c("div", {
    staticClass: "team-grid"
  }, [_c("div", {
    staticClass: "team-item"
  }, [_c("label", [_vm._v("Sales Manager")]), _c("span", [_vm._v(_vm._s((_vm$lead$salesManager = _vm.lead.salesManager) === null || _vm$lead$salesManager === void 0 ? void 0 : _vm$lead$salesManager.fullName))])]), _c("div", {
    staticClass: "team-item"
  }, [_c("label", [_vm._v("Coordinator")]), _c("span", [_vm._v(_vm._s((_vm$lead$salesCoordin = _vm.lead.salesCoordinator) === null || _vm$lead$salesCoordin === void 0 ? void 0 : _vm$lead$salesCoordin.fullName))])]), _c("div", {
    staticClass: "team-item"
  }, [_c("label", [_vm._v("Created By")]), _c("span", [_vm._v(_vm._s((_vm$lead$salesManager2 = _vm.lead.salesManager) === null || _vm$lead$salesManager2 === void 0 ? void 0 : _vm$lead$salesManager2.fullName))])])])], 2), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-data-line"
  }), _vm._v(" Source ")]), _c("div", {
    staticClass: "source-action"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      effect: "light"
    }
  }, [_vm._v(" " + _vm._s((_vm$lead$source = _vm.lead.source) === null || _vm$lead$source === void 0 ? void 0 : _vm$lead$source.name) + " ")])], 1)], 2), _vm.lead.productAction === "Sourcing" ? _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-goods"
  }), _vm._v(" Sourcing Details ")]), _c("div", {
    staticClass: "sourcing-preview"
  }, [_c("strong", [_vm._v(_vm._s(_vm.lead.sourcingProductName))]), _vm.lead.sourcingProductImage && _vm.lead.sourcingProductImage.length > 0 ? _c("el-image", {
    staticClass: "preview-img",
    attrs: {
      src: _vm.lead.sourcingProductImage[0],
      "preview-src-list": _vm.lead.sourcingProductImage,
      fit: "cover"
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-wallet"
  }), _vm._v(" Budget ")]), _c("div", {
    staticClass: "budget-info"
  }, [_c("div", {
    staticClass: "budget-item"
  }, [_c("label", [_vm._v("Quantity")]), _c("span", {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.lead.quantity))])]), _vm.lead.productAction === "Send Options" ? _c("div", {
    staticClass: "budget-item"
  }, [_c("label", [_vm._v("Budget")]), _c("span", {
    staticClass: "val highlight"
  }, [_vm._v("₹" + _vm._s(parseFloat(_vm.lead.budget).toLocaleString("en-IN")))])]) : _vm._e()])], 2), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-time"
  }), _vm._v(" Timeline ")]), _c("div", {
    staticClass: "timeline-info-row"
  }, [_c("div", {
    staticClass: "time-chip"
  }, [_c("i", {
    staticClass: "el-icon-date"
  }), _c("span", {
    staticClass: "time-chip-label"
  }, [_vm._v("Created")]), _c("span", {
    staticClass: "time-chip-val"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lead.createdTimestamp, "DD MMM YYYY")))])]), _c("span", {
    staticClass: "time-sep"
  }, [_vm._v("→")]), _c("div", {
    staticClass: "time-chip"
  }, [_c("i", {
    staticClass: "el-icon-date"
  }), _c("span", {
    staticClass: "time-chip-label"
  }, [_vm._v("Close by")]), _c("span", {
    staticClass: "time-chip-val"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lead.expectedClosureDate, "DD MMM YYYY")))])]), _c("span", {
    staticClass: "time-sep"
  }, [_vm._v("·")]), _c("div", {
    staticClass: "time-chip"
  }, [_c("i", {
    staticClass: "el-icon-time"
  }), _c("span", {
    staticClass: "time-chip-label"
  }, [_vm._v("Delivery")]), _c("span", {
    staticClass: "time-chip-val"
  }, [_vm._v(_vm._s(_vm.lead.tentativeDeliveryDuration) + "d")])])])], 2), _vm.lead.presentationUrl || _vm.lead.pdfUrl ? _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-files"
  }), _vm._v(" Documents ")]), _c("div", {
    staticClass: "doc-actions"
  }, [_vm.lead.presentationUrl ? _c("el-link", {
    staticClass: "doc-pill",
    attrs: {
      href: _vm.lead.presentationUrl,
      target: "_blank"
    }
  }, [_c("i", {
    staticClass: "el-icon-view"
  }), _vm._v(" Presentation ")]) : _vm._e(), _vm.lead.pdfUrl ? _c("el-link", {
    staticClass: "doc-pill",
    attrs: {
      href: _vm.lead.pdfUrl,
      target: "_blank"
    }
  }, [_c("i", {
    staticClass: "el-icon-document"
  }), _vm._v(" Quotation ")]) : _vm._e()], 1)], 2) : _vm._e(), _vm.lead.comments && _vm.lead.comments.length > 0 ? _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-edit"
  }), _vm._v(" Comments ")]), _c("div", {
    staticClass: "comment-list"
  }, [_vm._v(" " + _vm._s(_vm.lead.comments) + " ")])], 2) : _vm._e(), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" Stats ")]), _c("div", {
    staticClass: "stats-grid"
  }, [_c("div", {
    staticClass: "stat-chip"
  }, [_c("span", {
    staticClass: "stat-label"
  }, [_vm._v("Closing Date")]), _c("span", {
    staticClass: "stat-val"
  }, [_vm._v(_vm._s(_vm.leadStats.wonDate ? _vm.$moment(_vm.leadStats.wonDate).format("DD/MM/YYYY") : "—"))])]), _c("div", {
    staticClass: "stat-chip"
  }, [_c("span", {
    staticClass: "stat-label"
  }, [_vm._v("Rejections")]), _c("span", {
    staticClass: "stat-val stat-warn"
  }, [_vm._v(_vm._s(_vm.leadStats.rejectedCount))])]), _c("div", {
    staticClass: "stat-chip"
  }, [_c("span", {
    staticClass: "stat-label"
  }, [_vm._v("Revisions")]), _c("span", {
    staticClass: "stat-val stat-warn"
  }, [_vm._v(_vm._s(_vm.leadStats.revisedCount))])]), _c("div", {
    staticClass: "stat-chip stat-chip--wide"
  }, [_c("span", {
    staticClass: "stat-label"
  }, [_vm._v("Rejected after Quote Approved")]), _c("span", {
    staticClass: "stat-val",
    class: _vm.leadStats.rejectedAfterApproval ? "stat-danger" : ""
  }, [_vm._v(_vm._s(_vm.leadStats.rejectedAfterApproval ? "Yes" : "No"))])])])], 2)], 1)], 1), _vm.lead.poNumber ? _c("el-card", {
    staticClass: "detail-card info-card shadow-sm",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticClass: "card-header gradient-orange-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", {
    staticClass: "header-title"
  }, [_c("i", {
    staticClass: "el-icon-info icon-accent"
  }), _vm._v(" Purchase Order Details")]), _c("div", {
    staticClass: "header-actions"
  }, [_vm.lead.status !== "lost" ? _c("el-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      size: "mini",
      type: "warning",
      icon: "el-icon-edit"
    },
    on: {
      click: function ($event) {
        return _vm.openPODialog();
      }
    }
  }, [_vm._v(" Edit PO ")]) : _vm._e(), _c("div", {
    class: "status-badge status-" + _vm.lead.status
  }, [_vm._v(" " + _vm._s(_vm.lead.status) + " ")])], 1)]), _c("el-descriptions", {
    staticClass: "beautified-descriptions",
    attrs: {
      column: 1,
      size: "medium",
      border: ""
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-key"
  }), _vm._v(" PO Number ")]), _c("span", {
    staticClass: "id-text"
  }, [_vm._v("#" + _vm._s(_vm.lead.poNumber))])], 2), _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-wallet"
  }), _vm._v(" Budget & Qty ")]), _c("div", {
    staticClass: "budget-info"
  }, [_c("div", {
    staticClass: "budget-item"
  }, [_c("label", [_vm._v("PO Amount")]), _c("span", {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.lead.poAmount))])]), _vm.lead.productAction === "Send Options" ? _c("div", {
    staticClass: "budget-item"
  }, [_c("label", [_vm._v("Budget")]), _c("span", {
    staticClass: "val highlight"
  }, [_vm._v("₹" + _vm._s(parseFloat(_vm.lead.budget).toLocaleString("en-IN")))])]) : _vm._e()])], 2), _vm.lead.presentationUrl || _vm.lead.pdfUrl ? _c("el-descriptions-item", {
    attrs: {
      "label-class-name": "desc-label"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-files"
  }), _vm._v(" Documents ")]), _c("div", {
    staticClass: "doc-actions"
  }, [_vm.lead.poFile ? _c("el-link", {
    staticClass: "doc-pill",
    attrs: {
      href: _vm.lead.poFile,
      target: "_blank"
    }
  }, [_c("i", {
    staticClass: "el-icon-view"
  }), _vm._v(" PO Document ")]) : _vm._e()], 1)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm.productList.length ? _c("el-card", {
    staticClass: "detail-card product-card",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticClass: "card-header gradient-orange-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", {
    staticClass: "header-title"
  }, [_c("i", {
    staticClass: "el-icon-shopping-cart-2 icon-accent"
  }), _vm._v(" Products")]), _c("div", {
    staticClass: "header-actions"
  }, [_c("span", {
    staticClass: "count-badge"
  }, [_vm._v(_vm._s(_vm.productList.length))])])]), _c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    staticClass: "modern-table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.productList
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "product.name",
      label: "Product",
      "min-width": "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Price",
      width: "100",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticClass: "price-text"
        }, [_vm._v("₹" + _vm._s((scope.row.salePrice || scope.row.unitPrice).toLocaleString("en-IN")))])];
      }
    }], null, false, 3764059227)
  }), _c("el-table-column", {
    attrs: {
      prop: "quantity",
      label: "Qty",
      width: "50",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Sub-Total",
      width: "100",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticClass: "total-text"
        }, [_vm._v(" ₹" + _vm._s(((scope.row.salePrice || scope.row.unitPrice) * scope.row.quantity).toLocaleString("en-IN")) + " ")])];
      }
    }], null, false, 3936348559)
  })], 1)], 1)]) : _vm._e(), _c("el-row", {
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "20px"
    }
  }, [_c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "95%",
      title: "Lost Lead",
      visible: _vm.lostInquiryFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog responsive-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.lostInquiryFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Loss"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.leadRejectReason,
      callback: function ($$v) {
        _vm.leadRejectReason = $$v;
      },
      expression: "leadRejectReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Comments",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.leadRejectReasonComment,
      callback: function ($$v) {
        _vm.leadRejectReasonComment = $$v;
      },
      expression: "leadRejectReasonComment"
    }
  })], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Reject");
      }
    }
  }, [_vm._v(" Confirm Loss ")])], 1)], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "600px",
      margin: "0 auto"
    },
    attrs: {
      title: "Sample Products",
      visible: _vm.dialogTableVisible,
      width: "95%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogTableVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    attrs: {
      data: _vm.sampleProductList
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      width: "55"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Name",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.name))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Info",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.product.isSampleAvailable ? _c("span", [_vm._v(_vm._s(scope.row.product.sampleType))]) : _c("span", {
          staticStyle: {
            color: "grey"
          }
        }, [_vm._v("Not available")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          staticStyle: {
            width: "fit-content"
          },
          attrs: {
            placeholder: "Quantity",
            type: "number",
            min: 1,
            controls: false,
            size: "mini"
          },
          model: {
            value: scope.row.product.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row.product, "quantity", $$v);
            },
            expression: "scope.row.product.quantity"
          }
        })];
      }
    }])
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogTableVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addSampleLeadProducts
    }
  }, [_vm._v("Confirm")])], 1)]), _c("el-dialog", {
    style: {
      maxWidth: "700px",
      margin: "0 auto"
    },
    attrs: {
      title: _vm.sampleTitle,
      visible: _vm.dialogSampleFollowUpVisible,
      width: "95%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogSampleFollowUpVisible = $event;
      }
    }
  }, [_vm.sample.currentStatus !== "Initiated" ? _c("div", {
    staticClass: "form-block",
    staticStyle: {
      margin: "10px 0",
      width: "100%"
    }
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.sample,
      "status-icon": "",
      "label-position": "top"
    }
  }, [_vm.sample.currentStatus === "Arranged" || _vm.sample.currentStatus === "Arrange Return Pick-up" ? _c("el-form-item", {
    attrs: {
      label: "Is Local",
      prop: "isLocal"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.sample.isLocal,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "isLocal", $$v);
      },
      expression: "sample.isLocal"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arranged" && !_vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Delivery Assigned To",
      prop: "assignedTo"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Transporter"
    },
    model: {
      value: _vm.sample.transporter,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "transporter", $$v);
      },
      expression: "sample.transporter"
    }
  }, _vm._l(_vm.transporters, function (transporter) {
    return _c("el-option", {
      key: transporter.id,
      attrs: {
        label: transporter.name,
        value: transporter.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.sample.currentStatus === "Arranged" || _vm.sample.currentStatus === "Shipped" ? _c("el-form-item", {
    attrs: {
      label: "Expected Delivery Time",
      prop: "expectedDeliveryTime"
    },
    model: {
      value: _vm.sample.sampleExpectedDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleExpectedDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleExpectedDeliveryTimestamp"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "datetime",
      format: "dd-MM-yyyy HH:mm",
      "default-value": new Date(),
      "picker-options": _vm.pickerOptions,
      disabled: _vm.sample.currentStatus === "Shipped"
    },
    model: {
      value: _vm.sample.sampleExpectedDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleExpectedDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleExpectedDeliveryTimestamp"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Shipped" ? _c("el-form-item", {
    attrs: {
      label: "Actual Delivery Time",
      prop: "actualDeliveryTimestamp"
    },
    model: {
      value: _vm.sample.sampleActualDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleActualDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleActualDeliveryTimestamp"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "datetime",
      format: "dd-MM-yyyy HH:mm",
      "picker-options": _vm.pickerOptions,
      "default-value": new Date()
    },
    model: {
      value: _vm.sample.sampleActualDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleActualDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleActualDeliveryTimestamp"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Delivered" ? _c("el-form-item", {
    attrs: {
      label: "Return Date",
      prop: "returnDate"
    },
    model: {
      value: _vm.sample.sampleReturnDate,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleReturnDate", $$v);
      },
      expression: "sample.sampleReturnDate"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.sample.sampleReturnDate,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleReturnDate", $$v);
      },
      expression: "sample.sampleReturnDate"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arranged" && !_vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Delivery AWB Details",
      prop: "deliveryAwbDetails"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "AWB Details"
    },
    model: {
      value: _vm.sample.deliveryAwbDetails,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "deliveryAwbDetails", $$v);
      },
      expression: "sample.deliveryAwbDetails"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arranged" && _vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Delivery Boy Details",
      prop: "deliveryBoyDetails"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Delivery Boy Details",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      }
    },
    model: {
      value: _vm.sample.deliveryBoyDetails,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "deliveryBoyDetails", $$v);
      },
      expression: "sample.deliveryBoyDetails"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arrange Return Pick-up" || _vm.sample.currentStatus === "Return shipped" ? _c("el-form-item", {
    attrs: {
      label: "Expected Return Date",
      prop: "expectedReturnDeliveryTime"
    },
    model: {
      value: _vm.sample.sampleExpectedReturnDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleExpectedReturnDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleExpectedReturnDeliveryTimestamp"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions,
      disabled: _vm.sample.currentStatus === "Return shipped"
    },
    model: {
      value: _vm.sample.sampleExpectedReturnDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleExpectedReturnDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleExpectedReturnDeliveryTimestamp"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arrange Return Pick-up" && !_vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Return Delivery By",
      prop: "assignedTo"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Transporter"
    },
    model: {
      value: _vm.sample.returnTransporter,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "returnTransporter", $$v);
      },
      expression: "sample.returnTransporter"
    }
  }, _vm._l(_vm.transporters, function (transporter) {
    return _c("el-option", {
      key: transporter.id,
      attrs: {
        label: transporter.name,
        value: transporter.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.sample.currentStatus === "Arrange Return Pick-up" && !_vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Return AWB Details",
      prop: "returnAwbDetails"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "AWB Details"
    },
    model: {
      value: _vm.sample.returnAwbDetails,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "returnAwbDetails", $$v);
      },
      expression: "sample.returnAwbDetails"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Arrange Return Pick-up" && _vm.sample.isLocal ? _c("el-form-item", {
    attrs: {
      label: "Return Delivery Details",
      prop: "returnDeliveryBoyDetails"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Return Delivery Boy Details",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      }
    },
    model: {
      value: _vm.sample.returnDeliveryBoyDetails,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "returnDeliveryBoyDetails", $$v);
      },
      expression: "sample.returnDeliveryBoyDetails"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Return shipped" ? _c("el-form-item", {
    attrs: {
      label: "Return Delivery Date",
      prop: "returnDate"
    },
    model: {
      value: _vm.sample.sampleActualReturnDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleActualReturnDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleActualReturnDeliveryTimestamp"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.sample.sampleActualReturnDeliveryTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleActualReturnDeliveryTimestamp", $$v);
      },
      expression: "sample.sampleActualReturnDeliveryTimestamp"
    }
  })], 1) : _vm._e(), _vm.sample.currentStatus === "Returned Verified" ? _c("el-form-item", {
    attrs: {
      label: "Return Completed on",
      prop: "sampleCompletedsampleReturnCompletedTimestampTimestamp"
    },
    model: {
      value: _vm.sample.sampleReturnCompletedTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleReturnCompletedTimestamp", $$v);
      },
      expression: "sample.sampleReturnCompletedTimestamp"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.sample.sampleReturnCompletedTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.sample, "sampleReturnCompletedTimestamp", $$v);
      },
      expression: "sample.sampleReturnCompletedTimestamp"
    }
  })], 1) : _vm._e()], 1), _vm.sample.currentStatus === "Returned Delivered" ? _c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    attrs: {
      data: _vm.sample.sampleLeadProduct,
      border: ""
    },
    on: {
      "selection-change": _vm.handleConditionSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      width: "40"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Name",
      "min-width": "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.name))])];
      }
    }], null, false, 125423300)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Type",
      "min-width": "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.sampleType))])];
      }
    }], null, false, 735678493)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "70",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.quantity))])];
      }
    }], null, false, 2476752509)
  }), _c("el-table-column", {
    attrs: {
      label: "Is Return Condition Good",
      width: "80",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-switch", {
          model: {
            value: scope.row.isReturnConditionGood,
            callback: function ($$v) {
              _vm.$set(scope.row, "isReturnConditionGood", $$v);
            },
            expression: "scope.row.isReturnConditionGood"
          }
        })];
      }
    }], null, false, 2455616717)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Image",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("file-upload", {
          attrs: {
            url: "/common/upload",
            "file-list": _vm.images[scope.$index],
            accept: ".jpg, .jpeg, .png",
            "max-size": 1,
            limit: 1
          },
          on: {
            change: function ($event) {
              return _vm.returnImageUploaded($event, scope.$index);
            }
          }
        })];
      }
    }], null, false, 167897476)
  }), _c("el-table-column", {
    attrs: {
      label: "Comments",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          attrs: {
            placeholder: "Comments / Condition"
          },
          model: {
            value: scope.row.comments,
            callback: function ($$v) {
              _vm.$set(scope.row, "comments", $$v);
            },
            expression: "scope.row.comments"
          }
        })];
      }
    }], null, false, 2328060956)
  })], 1)], 1) : _vm._e(), _c("br")], 1), _vm.sample.currentStatus === "Delivered" ? _c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    attrs: {
      data: _vm.sample.sampleLeadProduct,
      border: ""
    },
    on: {
      "selection-change": _vm.handleReturnSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      width: "55"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Name",
      "min-width": "140",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.name))])];
      }
    }], null, false, 125423300)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Type",
      "min-width": "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.sampleType))])];
      }
    }], null, false, 735678493)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "70",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.quantity))])];
      }
    }], null, false, 2476752509)
  }), _c("el-table-column", {
    attrs: {
      label: "IsReturnDeclined",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-switch", {
          model: {
            value: scope.row.isReturnDeclined,
            callback: function ($$v) {
              _vm.$set(scope.row, "isReturnDeclined", $$v);
            },
            expression: "scope.row.isReturnDeclined"
          }
        })];
      }
    }], null, false, 2768389845)
  }), _c("el-table-column", {
    attrs: {
      label: "Return Declined Reason",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.isReturnDeclined ? _c("el-input", {
          attrs: {
            placeholder: "Return Declined Reason"
          },
          model: {
            value: scope.row.returnDeclinedReason,
            callback: function ($$v) {
              _vm.$set(scope.row, "returnDeclinedReason", $$v);
            },
            expression: "scope.row.returnDeclinedReason"
          }
        }) : _vm._e()];
      }
    }], null, false, 3910534279)
  })], 1)], 1) : _vm._e(), _vm.sample.currentStatus === "Return initiated" ? _c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    attrs: {
      data: _vm.sample.sampleLeadProduct,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Name",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.name))])];
      }
    }], null, false, 125423300)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Type",
      "min-width": "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.sampleType))])];
      }
    }], null, false, 735678493)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "70",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.quantity))])];
      }
    }], null, false, 2476752509)
  }), _c("el-table-column", {
    attrs: {
      label: "Return Declined Reason",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.returnDeclinedReason) + " ")];
      }
    }], null, false, 3949774779)
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm.sample.currentStatus === "Initiated" ? _c("div", {
    staticClass: "table-scroll-wrapper"
  }, [_c("el-table", {
    attrs: {
      data: _vm.sample.sampleLeadProduct,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Name",
      "min-width": "140",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.name))])];
      }
    }], null, false, 125423300)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Type",
      "min-width": "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.product.sampleType))])];
      }
    }], null, false, 735678493)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.quantity))])];
      }
    }], null, false, 2476752509)
  })], 1)], 1) : _vm._e(), _c("br"), _vm.sample.currentStatus === "Return initiated" ? _c("div", {
    staticStyle: {
      "text-align": "center",
      float: "left"
    }
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.approveLoading,
      expression: "approveLoading"
    }],
    attrs: {
      type: "success",
      size: "mini"
    },
    on: {
      click: _vm.returnDeclineAccepted
    }
  }, [_vm._v(" Approve ")]), _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.rejectLoading,
      expression: "rejectLoading"
    }],
    attrs: {
      type: "danger",
      size: "mini"
    },
    on: {
      click: _vm.returnDeclineRejected
    }
  }, [_vm._v(" Reject ")])], 1) : _c("div", {
    staticStyle: {
      "text-align": "center",
      float: "left"
    }
  }, [_vm.sample.currentStatus === "Initiated" ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      type: "danger",
      size: "mini"
    },
    on: {
      click: _vm.sampleCancelled
    }
  }, [_vm._v(" Cancel ")]) : _vm._e(), _vm.sample.currentStatus === "Initiated" ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    attrs: {
      type: "success",
      size: "mini"
    },
    on: {
      click: _vm.sampleArranged
    }
  }, [_vm._v(" Sample Arranged ")]) : _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    attrs: {
      type: "success",
      size: "mini"
    },
    on: {
      click: _vm.saveSample
    }
  }, [_vm._v(" Submit ")])], 1), _c("br")])], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 24,
      md: 15,
      lg: 15
    }
  }, [_c("div", {
    staticClass: "timeline-container"
  }, [_c("div", {
    staticClass: "timeline-header"
  }, [_c("h3", [_vm._v("Activity Timeline")]), _c("el-tag", {
    attrs: {
      size: "small",
      type: "info",
      effect: "plain"
    }
  }, [_vm._v(" " + _vm._s(_vm.followupList.length) + " Entries ")])], 1), _c("el-timeline", {
    staticClass: "modern-timeline"
  }, _vm._l(_vm.displayFollowupList, function (followup) {
    var _followup$assignedUse, _followup$assignedUse2;
    return _c("el-timeline-item", {
      key: followup.id,
      attrs: {
        timestamp: _vm._f("moment")(followup.completedTimestamp || followup.dueDate, "MMM D, YYYY · h:mm A"),
        placement: "top",
        "hide-timestamp": ""
      }
    }, [_c("template", {
      slot: "dot"
    }, [_c("div", {
      staticClass: "tl-dot",
      class: "tl-dot--" + _vm.getFollowupColour(_vm.lead.status === "Won" || _vm.lead.status === "Lost" ? "Completed" : followup.status)
    }, [_c("i", {
      class: _vm.getFollowupIcon(_vm.lead.status === "Won" || _vm.lead.status === "Lost" ? "Completed" : followup.status)
    })])]), _c("el-card", {
      staticClass: "followup-card",
      attrs: {
        shadow: "hover"
      }
    }, [_c("div", {
      staticClass: "tl-timestamp"
    }, [_vm._v(" " + _vm._s(_vm._f("moment")(followup.completedTimestamp || followup.dueDate, "MMM D, YYYY · h:mm A")) + " ")]), _c("div", {
      staticClass: "followup-header"
    }, [_c("div", {
      staticClass: "agenda-row"
    }, [_c("span", {
      staticClass: "agenda-text"
    }, [_vm._v(_vm._s(_vm.agendaLabels[followup.agenda] || followup.agenda))]), _c("el-tag", {
      staticClass: "priority-tag",
      attrs: {
        type: _vm.getPrirityColor(followup.priority),
        size: "mini",
        effect: "dark"
      }
    }, [_vm._v(" " + _vm._s(followup.priority) + " ")])], 1), _c("div", {
      staticClass: "action-zone"
    }, [followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" && (followup.assignedTo === _vm.loggedInUser.id || followup.isSuperAdminTask === _vm.loggedInUser.roles.indexOf("Super Admin") > -1) ? _c("el-button", {
      staticClass: "followup-btn",
      attrs: {
        type: "primary",
        size: "small",
        icon: "el-icon-check"
      },
      on: {
        click: function ($event) {
          return _vm.doFollowUp(followup.agenda);
        }
      }
    }, [_vm._v(" Take Followup ")]) : _c("el-tag", {
      attrs: {
        type: _vm.lead.status === "Won" || _vm.lead.status === "Lost" ? "success" : _vm.statusColorMap[followup.status],
        size: "small",
        effect: "dark"
      }
    }, [_c("i", {
      staticClass: "el-icon-success"
    }), _vm._v(" " + _vm._s(_vm.lead.status === "Won" || _vm.lead.status === "Lost" ? "Completed" : followup.status) + " ")])], 1)]), _c("div", {
      staticClass: "followup-body"
    }, [_c("p", {
      staticClass: "comment-text"
    }, [_vm._v(" " + _vm._s(followup.comments || "No additional comments provided.") + " ")]), followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" ? _c("div", {
      staticClass: "quick-actions"
    }, [_vm.$moment(followup.dueDate).isAfter(_vm.now) && followup.assignedTo === _vm.loggedInUser.id && (!followup.snoozeTimestamp || followup.snoozeTimestamp.length < 3) ? _c("el-button", {
      attrs: {
        size: "mini",
        plain: "",
        icon: "el-icon-alarm-clock"
      },
      on: {
        click: function ($event) {
          return _vm.handleCommand("snooze", followup);
        }
      }
    }, [_vm._v(" Snooze ")]) : _vm._e(), _vm.$moment(followup.dueDate).isAfter(_vm.now) && followup.assignedTo === _vm.loggedInUser.id && (!followup.rescheduleCount || followup.rescheduleCount < 3) ? _c("el-button", {
      attrs: {
        size: "mini",
        plain: "",
        icon: "el-icon-refresh"
      },
      on: {
        click: function ($event) {
          return _vm.handleCommand("reschedule", followup);
        }
      }
    }, [_vm._v(" Reschedule ")]) : _vm._e()], 1) : _vm._e()]), _c("div", {
      staticClass: "card-footer"
    }, [_c("div", {
      staticClass: "footer-due"
    }, [_c("span", {
      staticClass: "due-text"
    }, [_c("i", {
      staticClass: "el-icon-time",
      staticStyle: {
        color: "#409eff"
      }
    }), _vm._v(" " + _vm._s(_vm._f("moment")(followup.dueDate, "calendar")) + " "), followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" && _vm.$moment(followup.dueDate).isBefore(_vm.now) ? _c("i", {
      staticClass: "el-icon-s-flag",
      staticStyle: {
        color: "red"
      }
    }) : _vm._e()]), followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" ? _c("el-progress", {
      staticStyle: {
        "margin-top": "4px",
        width: "160px"
      },
      attrs: {
        percentage: _vm.getFollowupPercentage(followup.dueDate),
        "show-text": false,
        color: _vm.$moment(followup.dueDate).isBefore(_vm.now, "day") ? "#F56C6C" : _vm.getFollowupTimerColour(followup.dueDate)
      }
    }) : _vm._e(), followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" && _vm.isDueToday(followup.dueDate) ? _c("span", {
      staticClass: "countdown-text"
    }, [_c("el-statistic", {
      ref: "statistic",
      refInFor: true,
      attrs: {
        title: "",
        format: "HH:mm:ss",
        value: new Date(followup.dueDate).getTime(),
        "time-indices": ""
      }
    })], 1) : _vm._e(), followup.status !== "Completed" && _vm.lead.status !== "Won" && _vm.lead.status !== "Lost" && _vm.$moment(followup.dueDate).isBefore(_vm.now, "day") ? _c("span", {
      staticClass: "overdue-text"
    }, [_c("i", {
      staticClass: "el-icon-warning"
    }), _vm._v(" Overdue by " + _vm._s(_vm.$moment().diff(_vm.$moment(followup.dueDate), "days")) + " day(s) ")]) : _vm._e()], 1), _c("div", {
      staticClass: "footer-user"
    }, [_c("el-avatar", {
      attrs: {
        size: 28,
        src: (_followup$assignedUse = followup.assignedUser) === null || _followup$assignedUse === void 0 ? void 0 : _followup$assignedUse.avatar
      }
    }, [_c("img", {
      attrs: {
        src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
      }
    })]), _c("span", {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(((_followup$assignedUse2 = followup.assignedUser) === null || _followup$assignedUse2 === void 0 ? void 0 : _followup$assignedUse2.fullName) || (followup.isSuperAdminTask ? "Super Admin" : "")))])], 1)])])], 2);
  }), 1)], 1)]), ((_vm$selectedFollowup = _vm.selectedFollowup) === null || _vm$selectedFollowup === void 0 ? void 0 : _vm$selectedFollowup.status) !== "Completed" ? _c("el-dialog", {
    style: {
      maxWidth: "360px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      visible: _vm.snoozeFollowupVisible,
      "show-close": false,
      "append-to-body": "",
      "custom-class": "snooze-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.snoozeFollowupVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "snooze-dialog-body"
  }, [_c("div", {
    staticClass: "snooze-icon-wrap"
  }, [_c("i", {
    staticClass: "el-icon-alarm-clock"
  })]), _c("h3", {
    staticClass: "snooze-title"
  }, [_vm._v(" Snooze this follow-up? ")]), _c("p", {
    staticClass: "snooze-desc"
  }, [_vm._v(" You'll be reminded later. ")]), (_vm$selectedFollowup2 = _vm.selectedFollowup) !== null && _vm$selectedFollowup2 !== void 0 && _vm$selectedFollowup2.dueDate ? _c("div", {
    staticClass: "snooze-meta"
  }, [_c("i", {
    staticClass: "el-icon-time"
  }), _c("span", [_vm._v("Due: " + _vm._s(_vm._f("moment")(_vm.selectedFollowup.dueDate, "MMM D, YYYY · h:mm A")))])]) : _vm._e(), _c("div", {
    staticClass: "snooze-actions"
  }, [_c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function ($event) {
        _vm.snoozeFollowupVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.snoozeFollowup(_vm.selectedFollowup);
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-alarm-clock"
  }), _vm._v(" Snooze ")])], 1)])]) : _vm._e(), ((_vm$selectedFollowup3 = _vm.selectedFollowup) === null || _vm$selectedFollowup3 === void 0 ? void 0 : _vm$selectedFollowup3.status) !== "Completed" ? _c("el-dialog", {
    staticStyle: {
      "text-align": "center"
    },
    style: {
      maxWidth: "500px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Reschedule Follow-up",
      visible: _vm.rescheduleFollowupVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.rescheduleFollowupVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "rescheduleForm",
    staticClass: "responsive-form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reschedule Reason"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.rescheduleReason,
      callback: function ($$v) {
        _vm.rescheduleReason = $$v;
      },
      expression: "rescheduleReason"
    }
  }, _vm._l(_vm.resheduleReasons, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Reschedule Date"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "datetime",
      format: "dd-MM-yyyy HH:mm",
      placeholder: "Select Reschedule Date Time",
      "picker-options": _vm.reschedulePickerOptions
    },
    model: {
      value: _vm.selectedFollowup.rescheduleTime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedFollowup, "rescheduleTime", $$v);
      },
      expression: "selectedFollowup.rescheduleTime"
    }
  })], 1), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function ($event) {
        return _vm.rescheduleFollowup(_vm.selectedFollowup);
      }
    }
  }, [_vm._v(" Confirm ")])], 1)], 1) : _vm._e()], 1), _c("el-dialog", {
    style: {
      maxWidth: "450px",
      margin: "0 auto"
    },
    attrs: {
      title: "Lead Options Action",
      visible: _vm.clientOptionActionDialogVisible,
      width: "95%",
      "custom-class": "premium-dialog responsive-dialog",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.clientOptionActionDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "10px 0"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#6b7280",
      "font-size": "15px",
      "margin-bottom": "24px",
      "margin-top": "0"
    }
  }, [_vm._v(" What action would you like to take on these options? ")]), _c("div", {
    staticClass: "dialog-action-buttons"
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      border: "none",
      padding: "12px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(16, 185, 129, 0.3)"
    },
    attrs: {
      type: "success",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientOptionsUpdate("Approve");
      }
    }
  }, [_vm._v(" Approve ")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      border: "none",
      padding: "12px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.reviseOptionFormVisible = true;
      }
    }
  }, [_vm._v(" Revise ")])], 1)]), _c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Revise Options",
      visible: _vm.reviseOptionFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.reviseOptionFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Revision"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.reasonId,
      callback: function ($$v) {
        _vm.reasonId = $$v;
      },
      expression: "reasonId"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": "",
      placeholder: "Enter Comments"
    },
    model: {
      value: _vm.optionRejectReason,
      callback: function ($$v) {
        _vm.optionRejectReason = $$v;
      },
      expression: "optionRejectReason"
    }
  })], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientOptionsUpdate("Revise");
      }
    }
  }, [_vm._v(" Confirm Revise ")])], 1)], 1)], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "450px",
      margin: "0 auto"
    },
    attrs: {
      title: "Lead Action",
      visible: _vm.clientActionDialogVisible,
      width: "95%",
      "custom-class": "premium-dialog responsive-dialog",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.clientActionDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "10px 0"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#6b7280",
      "font-size": "15px",
      "margin-bottom": "24px",
      "margin-top": "0"
    }
  }, [_vm._v(" What action would you like to take on this quote? ")]), _c("div", {
    staticClass: "dialog-action-buttons"
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      border: "none",
      padding: "12px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(16, 185, 129, 0.3)"
    },
    attrs: {
      type: "success",
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.approveFormVisible = true;
      }
    }
  }, [_vm._v(" Approve ")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      border: "none",
      padding: "12px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.rejectFormVisible = true;
      }
    }
  }, [_vm._v(" Reject ")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      border: "none",
      padding: "12px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(245, 158, 11, 0.3)",
      color: "white"
    },
    attrs: {
      type: "warning",
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.reviseFormVisible = true;
      }
    }
  }, [_vm._v(" Revise ")])], 1)]), _c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Approve Quote",
      visible: _vm.approveFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.approveFormVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "10px 0 20px"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#6b7280",
      "font-size": "15px",
      margin: "0 0 24px"
    }
  }, [_vm._v(" Are you sure you want to approve this quote? ")]), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      gap: "12px"
    }
  }, [_c("el-button", {
    attrs: {
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.approveFormVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(16, 185, 129, 0.3)"
    },
    attrs: {
      type: "success",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Approve");
      }
    }
  }, [_vm._v(" OK ")])], 1)])]), _c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Reject Inquiry",
      visible: _vm.rejectFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.rejectFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Rejection"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.leadRejectReason,
      callback: function ($$v) {
        _vm.leadRejectReason = $$v;
      },
      expression: "leadRejectReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Comments",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.leadRejectReasonComment,
      callback: function ($$v) {
        _vm.leadRejectReasonComment = $$v;
      },
      expression: "leadRejectReasonComment"
    }
  })], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Reject");
      }
    }
  }, [_vm._v(" Confirm Reject ")])], 1)], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Revise Quote",
      visible: _vm.reviseFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.reviseFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Revision"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.quoteReviseReason,
      callback: function ($$v) {
        _vm.quoteReviseReason = $$v;
      },
      expression: "quoteReviseReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Comments",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.quoteReviseReasonComment,
      callback: function ($$v) {
        _vm.quoteReviseReasonComment = $$v;
      },
      expression: "quoteReviseReasonComment"
    }
  })], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(245, 158, 11, 0.3)",
      color: "white"
    },
    attrs: {
      type: "warning",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Revise");
      }
    }
  }, [_vm._v(" Confirm Revise ")])], 1)], 1)], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "500px",
      margin: "0 auto"
    },
    attrs: {
      title: _vm.quoteReceivedDialogTitle,
      visible: _vm.quoteReceivedDialogVisible,
      width: "95%",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.quoteReceivedDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      padding: "10px 20px"
    }
  }, [_c("p", {
    staticStyle: {
      "text-align": "center",
      color: "#6b7280",
      "font-size": "14px",
      "margin-top": "0",
      "margin-bottom": "24px"
    }
  }, [_vm._v(" Please confirm that the client has received the quotation. ")]), _c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Confirmation Date"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      placeholder: "Select confirmation date",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.selectedDate,
      callback: function ($$v) {
        _vm.selectedDate = $$v;
      },
      expression: "selectedDate"
    }
  })], 1), _c("div", {
    staticStyle: {
      background: "#f9fafb",
      border: "1px solid #e5e7eb",
      "border-radius": "8px",
      padding: "16px",
      "margin-top": "24px"
    }
  }, [_c("el-checkbox", {
    staticStyle: {
      display: "flex",
      "align-items": "flex-start",
      "font-weight": "600",
      color: "#374151",
      "font-size": "12px",
      "white-space": "normal",
      "line-height": "1.5",
      "word-break": "normal",
      "overflow-wrap": "break-word"
    },
    model: {
      value: _vm.resend,
      callback: function ($$v) {
        _vm.resend = $$v;
      },
      expression: "resend"
    }
  }, [_vm._v(" I confirm that I downloaded and emailed this quotation to the client. ")]), _vm.resend ? _c("div", {
    staticStyle: {
      "margin-top": "16px",
      "padding-top": "16px",
      "border-top": "1px solid #e5e7eb"
    }
  }, [_c("label", {
    staticStyle: {
      display: "block",
      "font-size": "13px",
      "font-weight": "600",
      color: "#6b7280",
      "margin-bottom": "8px"
    }
  }, [_vm._v("Reason / Comments for Resending")]), _c("el-input", {
    attrs: {
      placeholder: "Briefly explain why it was resent...",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.resendComments,
      callback: function ($$v) {
        _vm.resendComments = $$v;
      },
      expression: "resendComments"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      round: ""
    },
    on: {
      click: function ($event) {
        _vm.quoteReceivedDialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      border: "none",
      padding: "12px 28px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(16, 185, 129, 0.3)"
    },
    attrs: {
      type: "success",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteReceiptUpdate("Approve");
      }
    }
  }, [_vm._v(" Confirm & Complete ")])], 1)]), _c("el-dialog", {
    style: {
      maxWidth: "500px",
      margin: "0 auto"
    },
    attrs: {
      title: "Will you able to source requested products?",
      visible: _vm.sourceDialogVisible,
      width: "95%",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.sourceDialogVisible = $event;
      }
    }
  }, [_c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Reject Inquiry",
      visible: _vm.rejectFormVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.rejectFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Rejection"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.leadRejectReason,
      callback: function ($$v) {
        _vm.leadRejectReason = $$v;
      },
      expression: "leadRejectReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Comments",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.leadRejectReasonComment,
      callback: function ($$v) {
        _vm.leadRejectReasonComment = $$v;
      },
      expression: "leadRejectReasonComment"
    }
  })], 1), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Reject");
      }
    }
  }, [_vm._v(" Reject ")])], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.addSourcedProduct
    }
  }, [_vm._v(" Yes ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function ($event) {
        _vm.rejectFormVisible = true;
      }
    }
  }, [_vm._v("No")])], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "600px",
      margin: "0 auto"
    },
    attrs: {
      title: "Purchase Order Details",
      visible: _vm.getPODialogVisible,
      width: "95%",
      "custom-class": "premium-dialog responsive-dialog",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.getPODialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      "border-radius": "8px",
      padding: "20px",
      "margin-top": "10px"
    }
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.lead,
      "status-icon": "",
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "PO Number"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PO Number"
    },
    model: {
      value: _vm.lead.poNumber,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "poNumber", $$v);
      },
      expression: "lead.poNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PO Amount"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PO Amount",
      "prefix-icon": "el-icon-money"
    },
    model: {
      value: _vm.lead.poAmount,
      callback: function ($$v) {
        _vm.$set(_vm.lead, "poAmount", $$v);
      },
      expression: "lead.poAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PO File"
    }
  }, [_c("file-upload", {
    attrs: {
      url: "/common/upload",
      "file-list": _vm.fileList,
      "list-type": "text",
      accept: ".pdf, .jpg, .jpeg, .png",
      "max-size": 5,
      description: "(Note: PDF or Image file with a size less than 5mb)",
      limit: 1
    },
    on: {
      change: _vm.fileUploaded,
      remove: _vm.fileRemoved
    }
  })], 1), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      display: "flex",
      gap: "12px",
      "flex-wrap": "wrap"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      border: "none",
      padding: "10px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(16, 185, 129, 0.3)",
      "border-radius": "6px"
    },
    attrs: {
      type: "success"
    },
    on: {
      click: function ($event) {
        return _vm.addPODetails();
      }
    }
  }, [_vm._v(" Submit ")]), _c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      border: "none",
      padding: "10px 24px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(245, 158, 11, 0.3)",
      color: "white",
      "border-radius": "6px"
    },
    attrs: {
      type: "warning"
    },
    on: {
      click: function ($event) {
        _vm.rejectFormVisible = true;
      }
    }
  }, [_vm._v(" Lost ")])], 1)], 1)], 1), _c("el-dialog", {
    style: {
      maxWidth: "400px",
      margin: "0 auto"
    },
    attrs: {
      width: "90%",
      title: "Reject Inquiry",
      visible: _vm.rejectFormVisible,
      "append-to-body": "",
      "custom-class": "premium-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.rejectFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Reason for Rejection"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Reason"
    },
    model: {
      value: _vm.leadRejectReason,
      callback: function ($$v) {
        _vm.leadRejectReason = $$v;
      },
      expression: "leadRejectReason"
    }
  }, _vm._l(_vm.reasonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Additional Comments"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Comments",
      type: "textarea",
      rows: 3,
      autosize: {
        minRows: 3,
        maxRows: 4
      },
      maxlength: "250",
      "show-word-limit": ""
    },
    model: {
      value: _vm.leadRejectReasonComment,
      callback: function ($$v) {
        _vm.leadRejectReasonComment = $$v;
      },
      expression: "leadRejectReasonComment"
    }
  })], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    staticStyle: {
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      border: "none",
      padding: "10px 20px",
      "font-weight": "600",
      "box-shadow": "0 4px 14px rgba(239, 68, 68, 0.3)"
    },
    attrs: {
      type: "danger",
      round: ""
    },
    on: {
      click: function ($event) {
        return _vm.clientQuoteUpdate("Reject");
      }
    }
  }, [_vm._v(" Confirm Reject ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;